/* Homepage v2 (hp-*) behavior. Loaded deferred by several sections; runs once. */
(function () {
  if (window.__hpHomeInit) return;
  window.__hpHomeInit = true;

  var money = function (cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat).replace(/\.00$/, '');
    }
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- press: rotate quotes, logo tap shows its quote and restarts the timer ---------- */
  $$('[data-hp-press]').forEach(function (root) {
    var qs = $$('[data-hp-press-q]', root);
    var logos = $$('.hp-press__logo', root);
    if (logos.length < 2) return;
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var i = 0, timer;
    function show(n) {
      i = n;
      qs.forEach(function (x, j) { x.classList.toggle('is-on', j === n); });
      logos.forEach(function (b, j) { b.setAttribute('aria-pressed', j === n); });
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show((i + 1) % logos.length); }, ms); }
    logos.forEach(function (b, j) { b.addEventListener('click', function () { show(j); start(); }); });
    start();
  });

  /* ---------- shop cards: subscribe / one-time ---------- */
  $$('[data-hp-card]').forEach(function (form) {
    var plan = form.querySelector('[data-hp-plan]');
    var btn = form.querySelector('.hp-card__btn');
    $$('.hp-buy__o', form).forEach(function (o) {
      o.addEventListener('click', function () {
        $$('.hp-buy__o', form).forEach(function (x) { x.setAttribute('aria-checked', x === o); });
        if (plan) plan.disabled = o.getAttribute('data-mode') !== 'sub';
        btn.textContent = btn.getAttribute('data-hp-label') + ' · ' + o.getAttribute('data-price');
      });
    });
  });
  $$('[data-hp-shop]').forEach(function (root) {
    var rail = root.querySelector('[data-hp-rail]');
    var navs = $$('.hp-rail__nav', root);
    navs.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = rail.querySelector('.hp-card');
        var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 16) : rail.clientWidth / 2;
        rail.scrollBy({ left: +b.getAttribute('data-dir') * step, behavior: 'smooth' });
      });
    });
    // Show an arrow only when there is somewhere to scroll in that direction.
    function arrows() {
      var max = rail.scrollWidth - rail.clientWidth - 4;
      navs.forEach(function (b) { b.hidden = +b.getAttribute('data-dir') < 0 ? rail.scrollLeft <= 4 : rail.scrollLeft >= max; });
    }
    rail.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();
  });

  /* ---------- build your stack ---------- */
  $$('[data-hp-stack]').forEach(function (root) {
    var dataEl = root.querySelector('[data-hp-stack-json]');
    if (!dataEl) return;
    var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var P = D.products, byK = {};
    P.forEach(function (p) { byK[p.k] = p; });
    var CONF = {};
    if (D.conflict && D.conflict[0] && D.conflict[1]) { CONF[D.conflict[0]] = D.conflict[1]; CONF[D.conflict[1]] = D.conflict[0]; }
    var DICE = D.dice, FREE_AT = D.diceFreeAt || 4, BMIN = D.bundleMin || 3, BPCT = (D.bundlePct || 0) / 100;
    var sel = {}, diceSel = false, plan = 'sub';
    var res = root.querySelector('[data-hp-result]'), conf = root.querySelector('[data-hp-conflict]');
    var tiles = $$('.hp-tile', root);
    var sticky = root.querySelector('[data-hp-sticky]'), stickyT = root.querySelector('[data-hp-sticky-t]');
    var sv = function (p) { return '--c:' + p.c + ';--t:' + p.t; };
    var lower = function (s) { return s.charAt(0).toLowerCase() + s.slice(1); };

    tiles.forEach(function (t) {
      var k = t.getAttribute('data-k');
      if (CONF[k] && byK[CONF[k]]) t.querySelector('[data-why]').textContent = 'Not paired with ' + lower(byK[CONF[k]].goal);
    });

    function items() { return P.filter(function (p) { return sel[p.k]; }); }
    function diceState() { var n = items().length; return { on: !!DICE && (diceSel || n >= FREE_AT), free: !!DICE && n >= FREE_AT }; }
    function totals() {
      var it = items(), n = it.length, ds = diceState();
      var oneTot = it.reduce(function (s, p) { return s + p.one; }, 0) + (ds.on ? DICE.price : 0);
      var base = it.reduce(function (s, p) { return s + (plan === 'sub' && p.plan ? p.sub : p.one); }, 0);
      var bundle = n >= BMIN ? Math.round(base * BPCT) : 0;
      var total = base - bundle + (ds.on && !ds.free ? DICE.price : 0);
      var subSave = plan === 'sub' ? it.reduce(function (s, p) { return s + (p.plan ? p.one - p.sub : 0); }, 0) : 0;
      return { it: it, n: n, ds: ds, oneTot: oneTot, base: base, bundle: bundle, total: total, subSave: subSave };
    }
    function blocked(k) { return sel[k] || (CONF[k] && sel[CONF[k]]); }
    function suggest(it) {
      var pairs = { 'mate-endurance-premature-ejaculation-natural-supplement': 'mate-ignite-erectile-dysfunction-natural-supplement' };
      for (var a = 0; a < it.length; a++) { var c = pairs[it[a].k]; if (c && byK[c] && !blocked(c)) return byK[c]; }
      for (var b = 0; b < P.length; b++) { if (!blocked(P[b].k)) return P[b]; }
      return null;
    }

    function showConflict(k) {
      var want = byK[k], have = byK[CONF[k]];
      conf.innerHTML = '<b>' + have.goal + ' and ' + lower(want.goal) + ' work in opposite directions,</b> so ' + have.name + ' and ' + want.name +
        " aren't taken together. Pick the one that fits you.<button type=\"button\" data-swap=\"" + k + '">Switch to ' + lower(want.goal) + ' instead</button>';
      conf.classList.remove('is-on'); void conf.offsetWidth; conf.classList.add('is-on');
    }

    function render() {
      var T = totals(), ds = T.ds;
      tiles.forEach(function (t) {
        var k = t.getAttribute('data-k');
        if (k === 'dice') {
          t.setAttribute('aria-pressed', ds.on);
          t.classList.toggle('hp-tile--gift', ds.free);
          var f = t.querySelector('[data-dice-free]'); if (f) f.textContent = ds.free ? 'Included free' : 'Free with ' + FREE_AT + '+ products';
          return;
        }
        t.setAttribute('aria-pressed', !!sel[k]);
        t.classList.toggle('hp-tile--blocked', !!(CONF[k] && sel[CONF[k]]));
      });
      if (!T.n && !ds.on) {
        res.innerHTML = '<p class="hp-res__h" style="text-align:center">Your customized stack</p><p class="hp-res__empty">Tap a goal to start building.</p>';
        updateSticky(); return;
      }
      var all = T.it.concat(ds.on ? [DICE] : []);
      var sg = suggest(T.it), nudge = '';
      if (sg && T.n < BMIN) nudge = 'Add <b>' + (BMIN - T.n) + ' more</b> to save an extra ' + Math.round(BPCT * 100) + '% on your whole order.';
      else if (sg && DICE && T.n === FREE_AT - 1) nudge = 'Add <b>1 more</b> and the ' + DICE.name + ' is on us.';
      var h = '<div class="hp-res__head"><p class="hp-res__h">Your customized stack <span style="color:var(--hp-muted);font-weight:600">(' + all.length + ')</span></p>' +
        '<div class="hp-res__jars">' + all.map(function (p) { return '<img style="' + sv(p) + '" src="' + p.img + '" alt="">'; }).join('') + '</div></div><ul class="hp-lines">';
      T.it.forEach(function (p) {
        var sub = plan === 'sub' && p.plan;
        h += '<li class="hp-line" style="' + sv(p) + '"><span class="hp-line__img"><img src="' + p.img + '" alt=""></span><span><span class="hp-line__name">' + p.name +
          '</span><span class="hp-line__goal">' + p.goal + '</span><button type="button" class="hp-line__x" data-rm="' + p.k + '">Remove</button></span><span class="hp-line__price">' +
          (sub ? '<s>' + money(p.one) + '</s>' + money(p.sub) : money(p.one)) + '</span></li>';
      });
      if (ds.on) {
        h += '<li class="hp-line" style="' + sv(DICE) + '"><span class="hp-line__img"><img src="' + DICE.img + '" alt=""></span><span><span class="hp-line__name">' + DICE.name +
          '</span><span class="hp-line__goal">' + (ds.free ? 'Free gift with ' + FREE_AT + '+ products' : DICE.goal) + '</span>' + (ds.free ? '' : '<button type="button" class="hp-line__x" data-rm="dice">Remove</button>') +
          '</span><span class="hp-line__price">' + (ds.free ? '<s>' + money(DICE.price) + '</s><span class="hp-line__free">FREE</span>' : money(DICE.price)) + '</span></li>';
      }
      h += '</ul>';
      if (nudge) h += '<div class="hp-nudge">' + nudge + '<br><button type="button" class="hp-nudge__add" style="' + sv(sg) + '" data-add="' + sg.k + '">+ ' + sg.goal + ' · ' + sg.name + '</button></div>';
      if (T.n) h += '<div class="hp-plan"><button type="button" data-plan="sub" aria-pressed="' + (plan === 'sub') + '">Subscribe<small>Save 20% · cancel anytime</small></button>' +
        '<button type="button" data-plan="one" aria-pressed="' + (plan === 'one') + '">One-time<small>&nbsp;</small></button></div>';
      h += '<div class="hp-sum">';
      if (T.subSave) h += '<div class="hp-sum__row hp-sum__row--save"><span>Subscription savings</span><span>−' + money(T.subSave) + '</span></div>';
      if (T.bundle) h += '<div class="hp-sum__row hp-sum__row--save"><span>Bundle of ' + BMIN + '+ (extra ' + Math.round(BPCT * 100) + '%)</span><span>−' + money(T.bundle) + '</span></div>';
      if (ds.free) h += '<div class="hp-sum__row hp-sum__row--save"><span>Free ' + DICE.name + '</span><span>−' + money(DICE.price) + '</span></div>';
      h += '<div class="hp-sum__row hp-sum__row--total"><span>Today</span><span>' + (T.oneTot > T.total ? '<s>' + money(T.oneTot) + '</s>' : '') + money(T.total) + '</span></div>' +
        '<p class="hp-sum__fine">' + (plan === 'sub' && T.n ? 'Renews automatically on each product’s schedule. Pause or cancel anytime. ' : '') + 'Free, discreet shipping</p></div>' +
        '<button type="button" class="hp-btn hp-btn--block" data-hp-add>Add my stack to cart</button>';
      res.innerHTML = h;
      updateSticky();
    }

    function updateSticky() {
      if (!sticky) return;
      var T = totals(), cnt = T.n + (T.ds.on ? 1 : 0);
      var sec = root.getBoundingClientRect(), r = res.getBoundingClientRect(), vh = window.innerHeight;
      var inSec = sec.top < vh * 0.6 && sec.bottom > vh * 0.4, resVisible = r.top < vh - 60;
      if (cnt) {
        var hint = T.n >= FREE_AT && DICE ? 'Bundle savings + free gift applied' : T.n >= BMIN ? (DICE ? 'Add ' + (FREE_AT - T.n) + ' more for a free ' + DICE.name : 'Bundle savings applied') : 'Add ' + (BMIN - T.n) + ' more for an extra ' + Math.round(BPCT * 100) + '% off';
        stickyT.innerHTML = 'Your stack (' + cnt + ') · ' + money(T.total) + '<small>' + hint + '</small>';
      }
      sticky.classList.toggle('is-on', cnt > 0 && inSec && !resVisible && window.innerWidth < 900);
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    var sb = root.querySelector('[data-hp-sticky-btn]');
    if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); res.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    root.querySelector('[data-hp-tiles]').addEventListener('click', function (e) {
      var t = e.target.closest('.hp-tile'); if (!t) return;
      var k = t.getAttribute('data-k');
      if (k === 'dice') { if (diceState().free) return; diceSel = !diceSel; render(); return; }
      if (sel[k]) { delete sel[k]; conf.classList.remove('is-on'); }
      else if (CONF[k] && sel[CONF[k]]) { showConflict(k); return; }
      else { sel[k] = true; conf.classList.remove('is-on'); }
      render();
    });
    conf.addEventListener('click', function (e) {
      var k = e.target.getAttribute && e.target.getAttribute('data-swap'); if (!k) return;
      delete sel[CONF[k]]; sel[k] = true; conf.classList.remove('is-on'); render();
    });
    res.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-rm')) { var k = b.getAttribute('data-rm'); if (k === 'dice') diceSel = false; else delete sel[k]; render(); }
      else if (b.hasAttribute('data-add')) { sel[b.getAttribute('data-add')] = true; render(); }
      else if (b.hasAttribute('data-plan')) { plan = b.getAttribute('data-plan'); render(); }
      else if (b.hasAttribute('data-hp-add')) addStack(b);
    });

    function addStack(btn) {
      var T = totals();
      var lines = T.it.map(function (p) {
        var l = { id: p.id, quantity: 1 };
        if (plan === 'sub' && p.plan) l.selling_plan = +p.plan;
        return l;
      });
      // Paid dice only below the free threshold; at 4+ the theme's gift logic adds the free one.
      if (DICE && diceSel && !T.ds.free) lines.push({ id: DICE.id, quantity: 1 });
      if (!lines.length) return;
      btn.classList.add('is-loading'); btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: lines }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var $ = window.jQuery;
          if (typeof window.syncLocalStorageWithCart === 'function') window.syncLocalStorageWithCart(cart);
          if (typeof window.handleGiftLogic === 'function' && $) window.handleGiftLogic(cart, true, $(btn));
          else if ($) $('body').trigger('added.ajaxProduct', $(btn));
          if (typeof window.handleHiddenProducts === 'function') setTimeout(window.handleHiddenProducts, 200);
          btn.textContent = 'Added to cart ✓';
        })
        .catch(function () { btn.textContent = 'Something went wrong. Try again'; })
        .then(function () { btn.classList.remove('is-loading'); setTimeout(function () { btn.textContent = 'Add my stack to cart'; }, 2500); });
    }
    render();
  });

  /* ---------- legacy quiz links: /?quiz=1 and /#quiz-container land on Build your stack ---------- */
  (function () {
    /* also /#hp-stack (nav "Shop by Goal" and the drawer's Build your stack): the theme lands at the top
       on load otherwise. 'instant', not 'auto': auto follows base.css's smooth scrolling. */
    var want = /(^|[?&])quiz=1(&|$)/.test(location.search) || location.hash === '#quiz-container' || location.hash === '#hp-stack';
    var target = document.getElementById(location.hash === '#hp-stack' ? 'hp-stack' : 'quiz-container');
    if (!want || !target) return;
    var go = function () { target.scrollIntoView({ behavior: 'instant', block: 'start' }); };
    go(); window.addEventListener('load', function () { setTimeout(go, 50); });
  })();
  window.addEventListener('hashchange', function () {
    var t = document.getElementById('quiz-container');
    if (location.hash === '#quiz-container' && t) setTimeout(function () { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  });

  /* ---------- reviews by goal ---------- */
  $$('[data-hp-revs]').forEach(function (root) {
    var tabs = $$('.hp-rtab', root), revs = $$('.hp-rev', root);
    var meta = root.querySelector('[data-hp-rmeta]'), hint = meta ? meta.textContent : '';
    var grid = root.querySelector('[data-hp-rgrid]');
    var ALL_MAX = 6;
    function show(k) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-k') === k); });
      var shown = 0;
      revs.forEach(function (r) {
        var on = k === 'all' ? (r.getAttribute('data-first') === 'true' && shown < ALL_MAX) : r.getAttribute('data-k') === k;
        if (on) shown++;
        r.hidden = !on;
      });
      if (meta) {
        if (k === 'all') meta.textContent = hint;
        else {
          var t = tabs.filter(function (x) { return x.getAttribute('data-k') === k; })[0];
          meta.innerHTML = '';
          meta.appendChild(document.createTextNode(t.getAttribute('data-meta') || ''));
          var a = document.createElement('a'); a.href = t.getAttribute('data-url'); a.textContent = 'Shop ' + t.getAttribute('data-name');
          meta.appendChild(a);
        }
      }
      if (grid) grid.scrollLeft = 0;
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-k')); }); });
    show('all');
  });

  /* ---------- timeline ---------- */
  $$('[data-hp-tl]').forEach(function (root) {
    var tabs = $$('.hp-tl__tab', root), panels = $$('.hp-tl__panel', root);
    var curve = root.querySelector('[data-hp-tl-curve]'), mark = root.querySelector('[data-hp-tl-mark]');
    function pointAt(x) {
      var L = curve.getTotalLength(), lo = 0, hi = L;
      for (var j = 0; j < 30; j++) { var m = (lo + hi) / 2; if (curve.getPointAtLength(m).x < x) lo = m; else hi = m; }
      return curve.getPointAtLength(lo);
    }
    function show(i) {
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i); });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      var x = parseFloat(panels[i].getAttribute('data-x')) || 75, pt = pointAt(x);
      mark.style.transform = 'translate(' + pt.x + 'px,' + pt.y + 'px)';
    }
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    if (panels.length) show(0);
  });
})();
